import React, { useState, useEffect } from 'react';

// === DUMMY DATA ===
const courses = [
  { id: 1, title: "Foundation Batch", target: "Class 8th to 10th", duration: "1 Year", subjects: "Maths, Science, English, SST", icon: "📚", feature: "Strong Basics" },
  { id: 2, title: "Target JEE (Main + Adv)", target: "Engineering Entrance", duration: "2 Years", subjects: "Physics, Chemistry, Maths", icon: "🎯", feature: "Top IITian Faculty" },
  { id: 3, title: "Target NEET (Medical)", target: "Medical Entrance", duration: "2 Years", subjects: "Physics, Chemistry, Biology", icon: "🩺", feature: "In-depth Biology" },
  { id: 4, title: "Board Excellence", target: "Class 11th & 12th", duration: "1 Year", subjects: "PCM / PCB / Commerce", icon: "🏆", feature: "NCERT Focused" }
];

const faculty = [
  { name: "S.K. Singh", sub: "Physics", exp: "15+ Years", deg: "B.Tech, IIT Delhi", img: "https://images.unsplash.com/photo-1568602471122-7832951cc4c5?q=80&w=400" },
  { name: "Dr. Neha Verma", sub: "Biology", exp: "12+ Years", deg: "MBBS, AIIMS", img: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=400" },
  { name: "R.K. Gupta", sub: "Mathematics", exp: "20+ Years", deg: "M.Sc Maths", img: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=400" },
  { name: "Anjali Desai", sub: "Chemistry", exp: "8+ Years", deg: "M.Tech, NIT", img: "https://images.unsplash.com/photo-1580489944761-15a19d654956?q=80&w=400" }
];

const toppers = [
  { name: "Aarav Sharma", score: "98.5%", exam: "CBSE 12th", img: "https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?q=80&w=400" },
  { name: "Rohan Verma", score: "AIR 452", exam: "JEE Mains", img: "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?q=80&w=400" },
  { name: "Sneha Patel", score: "680/720", exam: "NEET UG", img: "https://images.unsplash.com/photo-1544717305-2782549b5136?q=80&w=400" },
  { name: "Priya Singh", score: "97.2%", exam: "CBSE 10th", img: "https://images.unsplash.com/photo-1517486808906-6ca8b3f04846?q=80&w=400" }
];

// === COMPONENT ===
const CoachingMid: React.FC = () => {
  type Page = 'home' | 'courses' | 'faculty' | 'results' | 'admission';
  const [currentPage, setCurrentPage] = useState<Page>('home');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setIsMobileMenuOpen(false);
  }, [currentPage]);

  const handleForm = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitted(true);
    setTimeout(() => setIsSubmitted(false), 5000);
  };

  return (
    <div className="min-h-screen bg-slate-50 text-slate-800 font-sans flex flex-col selection:bg-yellow-200">
      
      {/* 1. ALERT BAR */}
      <div className="bg-green-600 text-white text-xs sm:text-sm font-bold py-2.5 px-6 text-center tracking-wide shadow-md">
        ✨ ADMISSIONS OPEN 2026-27: REGISTER NOW FOR THE SCHOLARSHIP TEST & GET UPTO 100% FEE WAIVER! ✨
      </div>

      {/* 2. NAVBAR */}
      <nav className="bg-white sticky top-0 z-50 border-b-4 border-yellow-400 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 h-20 flex items-center justify-between">
          <div className="flex items-center gap-2 cursor-pointer" onClick={() => setCurrentPage('home')}>
            <div className="w-10 h-10 bg-green-600 text-white rounded-lg flex items-center justify-center text-2xl font-black shadow-lg">V</div>
            <div className="leading-none">
              <span className="text-xl sm:text-2xl font-black text-slate-900 uppercase">Vidya Classes</span>
              <span className="text-[10px] uppercase tracking-widest text-green-600 font-bold block">Results You Can Trust</span>
            </div>
          </div>

          <div className="hidden lg:flex gap-8 text-xs font-bold uppercase tracking-widest">
            {['home', 'courses', 'faculty', 'results'].map(p => (
              <button key={p} onClick={() => setCurrentPage(p as Page)} className={`hover:text-green-600 transition ${currentPage === p ? 'text-green-600 border-b-2 border-green-600' : 'text-slate-500'}`}>{p}</button>
            ))}
          </div>

          <div className="flex items-center gap-4">
            <button onClick={() => setCurrentPage('admission')} className="bg-yellow-400 text-slate-900 px-6 py-2.5 rounded-full text-xs font-black uppercase tracking-widest hover:bg-yellow-500 transition shadow-md hidden sm:block">Apply Now</button>
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="lg:hidden text-green-600 text-3xl">☰</button>
          </div>
        </div>

        {/* Mobile Nav */}
        {isMobileMenuOpen && (
          <div className="lg:hidden bg-white border-b border-slate-200 p-6 flex flex-col gap-4 animate-fadeIn">
            {['home', 'courses', 'faculty', 'results', 'admission'].map(p => (
              <button key={p} onClick={() => setCurrentPage(p as Page)} className="text-left text-sm font-bold uppercase tracking-widest py-2 border-b border-slate-50">{p}</button>
            ))}
          </div>
        )}
      </nav>

      <main className="flex-grow animate-fadeIn">
        
        {/* ================= 1. HOME PAGE ================= */}
        {currentPage === 'home' && (
          <div className="animate-slideUp">
            
            {/* Hero */}
            <header className="relative bg-white py-16 md:py-28 px-6 border-b border-slate-100 overflow-hidden">
               <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-12 items-center relative z-10">
                 <div className="space-y-8">
                   <div className="inline-flex items-center gap-2 bg-green-50 text-green-700 px-4 py-2 rounded-full text-xs font-bold uppercase tracking-widest border border-green-100">
                     ⭐ City's Highest Success Rate
                   </div>
                   <h1 className="text-5xl md:text-7xl font-black text-slate-900 leading-tight">
                     Unlock Your <br/> <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-600 to-yellow-500">True Potential.</span>
                   </h1>
                   <p className="text-lg text-slate-600 leading-relaxed max-w-lg">
                     We don't just teach, we build foundations for a successful career. Join 5,000+ students who have cracked their dream exams with Vidya Classes.
                   </p>
                   <div className="flex flex-col sm:flex-row gap-5">
                     <button onClick={() => setCurrentPage('admission')} className="bg-green-600 text-white px-10 py-5 rounded-2xl font-black uppercase tracking-widest shadow-xl hover:bg-green-700 transition">Book Demo Class</button>
                     <button onClick={() => setCurrentPage('courses')} className="bg-yellow-400 text-slate-900 px-10 py-5 rounded-2xl font-black uppercase tracking-widest shadow-xl hover:bg-yellow-500 transition">View Batches</button>
                   </div>
                 </div>
                 <div className="relative h-[450px] md:h-[600px] rounded-[3rem] overflow-hidden shadow-2xl border-[12px] border-white">
                   <img src="https://images.unsplash.com/photo-1523240795612-9a054b0db644?q=80&w=1000" className="w-full h-full object-cover" alt="Student"/>
                   <div className="absolute top-8 right-8 bg-white p-6 rounded-3xl shadow-2xl text-center border-l-8 border-yellow-400">
                     <p className="text-4xl font-black text-slate-900">98%</p>
                     <p className="text-[10px] font-bold text-slate-500 uppercase tracking-widest">Board Results</p>
                   </div>
                 </div>
               </div>
               {/* Background Elements */}
               <div className="absolute top-0 right-0 w-96 h-96 bg-yellow-100 rounded-full blur-[120px] -z-10 opacity-60"></div>
               <div className="absolute bottom-0 left-0 w-96 h-96 bg-green-100 rounded-full blur-[120px] -z-10 opacity-60"></div>
            </header>

            {/* NEW: Why Choose Us (Added Length) */}
            <section className="py-24 px-6 bg-slate-50">
              <div className="max-w-7xl mx-auto text-center">
                <h2 className="text-4xl font-black text-slate-900 mb-16">The Vidya Advantage</h2>
                <div className="grid md:grid-cols-3 gap-10">
                  <div className="bg-white p-10 rounded-3xl shadow-sm border-b-8 border-green-600 hover:-translate-y-2 transition duration-300">
                    <span className="text-5xl block mb-6">👨‍🏫</span>
                    <h3 className="text-2xl font-bold mb-4">Expert Faculty</h3>
                    <p className="text-slate-600">Classes led by IITians and PhD holders with decades of teaching experience.</p>
                  </div>
                  <div className="bg-white p-10 rounded-3xl shadow-sm border-b-8 border-yellow-400 hover:-translate-y-2 transition duration-300">
                    <span className="text-5xl block mb-6">📝</span>
                    <h3 className="text-2xl font-bold mb-4">Mock Test Series</h3>
                    <p className="text-slate-600">Weekly tests exactly on the latest patterns of CBSE, JEE, and NEET.</p>
                  </div>
                  <div className="bg-white p-10 rounded-3xl shadow-sm border-b-8 border-green-600 hover:-translate-y-2 transition duration-300">
                    <span className="text-5xl block mb-6">💡</span>
                    <h3 className="text-2xl font-bold mb-4">Doubt Support</h3>
                    <p className="text-slate-600">Dedicated doubt-solving counters available for students even after class hours.</p>
                  </div>
                </div>
              </div>
            </section>

            {/* Quick Toppers Section */}
            <section className="py-24 px-6 bg-white border-y border-slate-100">
              <div className="max-w-7xl mx-auto">
                <div className="flex justify-between items-end mb-12">
                   <div>
                     <h2 className="text-4xl font-black text-slate-900">Success Stories</h2>
                     <p className="text-slate-500 mt-2">Celebrating our champions of 2024.</p>
                   </div>
                   <button onClick={() => setCurrentPage('results')} className="text-green-600 font-bold underline uppercase tracking-widest text-sm">View All Results</button>
                </div>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
                  {toppers.map((t, i) => (
                    <div key={i} className="text-center group">
                      <div className="w-32 h-32 md:w-40 md:h-40 mx-auto rounded-full overflow-hidden border-8 border-yellow-100 group-hover:border-yellow-400 transition-all duration-500 mb-4">
                        <img src={t.img} className="w-full h-full object-cover" alt={t.name}/>
                      </div>
                      <h4 className="font-bold text-lg">{t.name}</h4>
                      <p className="text-xs text-slate-500 font-bold uppercase">{t.exam}</p>
                      <div className="mt-2 inline-block bg-green-100 text-green-700 px-3 py-1 rounded-full font-black text-sm">{t.score}</div>
                    </div>
                  ))}
                </div>
              </div>
            </section>
          </div>
        )}

        {/* ================= 2. COURSES PAGE ================= */}
        {currentPage === 'courses' && (
          <div className="animate-slideUp pb-32">
            <div className="bg-green-600 py-20 px-6 text-center text-white">
              <h1 className="text-4xl md:text-6xl font-black mb-4">Our Batches</h1>
              <p className="text-green-100 text-lg">Choose the right program to excel in your exams.</p>
            </div>
            
            <div className="max-w-7xl mx-auto px-6 mt-16 grid md:grid-cols-2 gap-8">
              {courses.map(c => (
                <div key={c.id} className="bg-white p-8 rounded-3xl shadow-sm border border-slate-200 flex flex-col sm:flex-row gap-8 items-center sm:items-start hover:shadow-xl transition">
                  <div className="w-20 h-20 bg-yellow-100 rounded-2xl flex items-center justify-center text-4xl flex-shrink-0">{c.icon}</div>
                  <div className="flex-grow space-y-4 text-center sm:text-left">
                    <div>
                      <h3 className="text-2xl font-black text-slate-900">{c.title}</h3>
                      <p className="text-green-600 font-bold text-sm uppercase tracking-widest">{c.target}</p>
                    </div>
                    <p className="text-slate-500 text-sm italic">Subjects: {c.subjects}</p>
                    <div className="flex flex-wrap gap-2 justify-center sm:justify-start">
                       <span className="bg-slate-100 px-3 py-1 rounded-full text-[10px] font-bold uppercase">{c.duration}</span>
                       <span className="bg-yellow-100 px-3 py-1 rounded-full text-[10px] font-bold uppercase">{c.feature}</span>
                    </div>
                    <button onClick={() => setCurrentPage('admission')} className="w-full bg-slate-900 text-white py-3 rounded-xl font-bold uppercase tracking-widest text-xs hover:bg-green-600 transition">Enquire Now</button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* ================= 3. FACULTY PAGE ================= */}
        {currentPage === 'faculty' && (
          <div className="animate-slideUp pb-32 bg-white">
            <div className="bg-yellow-400 py-20 px-6 text-center text-slate-900">
               <h1 className="text-4xl md:text-6xl font-black mb-4 tracking-tight">The Best Mentors</h1>
               <p className="text-slate-700 text-lg">Learn from the experts who have created thousands of toppers.</p>
            </div>
            <div className="max-w-7xl mx-auto px-6 mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-10">
              {faculty.map((f, i) => (
                <div key={i} className="bg-slate-50 rounded-3xl overflow-hidden border border-slate-200 text-center group shadow-sm hover:shadow-2xl transition duration-500">
                  <div className="h-72 overflow-hidden bg-slate-200">
                    <img src={f.img} className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition duration-700 group-hover:scale-105" alt={f.name}/>
                  </div>
                  <div className="p-8">
                    <h3 className="text-2xl font-black text-slate-900 mb-1">{f.name}</h3>
                    <p className="text-green-600 font-bold uppercase text-[10px] tracking-widest mb-4">{f.sub}</p>
                    <p className="text-slate-500 text-sm mb-4">{f.deg}</p>
                    <div className="bg-white py-2 rounded-full border border-slate-100 text-xs font-bold text-slate-700">Exp: {f.exp}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* ================= 4. RESULTS PAGE ================= */}
        {currentPage === 'results' && (
          <div className="animate-slideUp pb-32 bg-slate-50">
             <div className="bg-slate-900 py-20 px-6 text-center text-white">
                <h1 className="text-4xl md:text-6xl font-black mb-4 text-yellow-400">Hall of Fame</h1>
                <p className="text-slate-400 text-lg max-w-2xl mx-auto">Results that speak louder than words. Year after year, we deliver excellence in every competitive exam.</p>
             </div>
             <div className="max-w-7xl mx-auto px-6 mt-20">
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-10">
                  {toppers.map((t, i) => (
                    <div key={i} className="bg-white p-8 rounded-[2.5rem] text-center shadow-xl border border-yellow-100 flex flex-col items-center">
                       <div className="w-32 h-32 rounded-full overflow-hidden border-[8px] border-green-50 mb-6">
                         <img src={t.img} className="w-full h-full object-cover" alt={t.name}/>
                       </div>
                       <h3 className="text-2xl font-black text-slate-900 mb-1">{t.name}</h3>
                       <p className="text-slate-500 font-bold uppercase tracking-widest text-xs mb-6">{t.exam}</p>
                       <div className="w-full py-4 bg-yellow-400 text-slate-900 rounded-2xl font-black text-3xl shadow-inner italic leading-none">{t.score}</div>
                    </div>
                  ))}
                </div>
             </div>
          </div>
        )}

        {/* ================= 5. ADMISSION PAGE ================= */}
        {currentPage === 'admission' && (
          <div className="animate-slideUp py-24 px-6 bg-white min-h-screen">
            <div className="max-w-5xl mx-auto bg-slate-50 rounded-[3rem] shadow-2xl border border-slate-100 overflow-hidden flex flex-col md:flex-row">
               <div className="md:w-2/5 bg-green-600 p-12 text-white flex flex-col justify-center relative overflow-hidden">
                 <div className="absolute -top-10 -right-10 w-40 h-40 bg-green-500 rounded-full opacity-50 blur-3xl"></div>
                 <div className="relative z-10">
                   <h2 className="text-4xl font-black mb-6 leading-tight">Begin Your Journey To Ranks.</h2>
                   <p className="text-green-100 text-lg mb-8 leading-relaxed">Schedule a personal counseling session with our academic experts. Understand the roadmap to your target exam.</p>
                   <div className="space-y-4 font-bold uppercase tracking-[0.2em] text-[10px]">
                      <p>📍 Main Campus, Delhi NCR</p>
                      <p>📞 Helpline: +91 98765 43210</p>
                   </div>
                 </div>
               </div>
               <div className="md:w-3/5 p-8 md:p-16">
                 {isSubmitted ? (
                   <div className="h-full flex flex-col items-center justify-center text-center space-y-6">
                     <span className="text-7xl">🎉</span>
                     <h3 className="text-3xl font-black text-slate-900">Application Received!</h3>
                     <p className="text-slate-500">Expect a callback from our counselors within 24 hours.</p>
                     <button onClick={() => setIsSubmitted(false)} className="text-green-600 font-bold underline">Apply for another student</button>
                   </div>
                 ) : (
                   <form onSubmit={handleForm} className="space-y-6">
                      <div className="grid sm:grid-cols-2 gap-6">
                         <div><label className="block text-[10px] font-black uppercase text-slate-400 mb-2 tracking-widest">Student Name</label><input required type="text" className="w-full bg-white border border-slate-200 p-4 rounded-2xl focus:border-green-600 outline-none transition" placeholder="John Doe"/></div>
                         <div><label className="block text-[10px] font-black uppercase text-slate-400 mb-2 tracking-widest">Mobile Number</label><input required type="tel" className="w-full bg-white border border-slate-200 p-4 rounded-2xl focus:border-green-600 outline-none transition" placeholder="+91 000..."/></div>
                      </div>
                      <div>
                        <label className="block text-[10px] font-black uppercase text-slate-400 mb-2 tracking-widest">Select Course</label>
                        <select className="w-full bg-white border border-slate-200 p-4 rounded-2xl focus:border-green-600 outline-none text-slate-700">
                          <option>JEE Preparation</option><option>NEET Preparation</option><option>Foundation Batch</option><option>Board Excellence</option>
                        </select>
                      </div>
                      <button type="submit" className="w-full bg-yellow-400 hover:bg-yellow-500 text-slate-900 font-black uppercase tracking-[0.2em] py-5 rounded-2xl shadow-xl transition active:scale-[0.98]">Confirm Appointment</button>
                   </form>
                 )}
               </div>
            </div>
          </div>
        )}

      </main>

      {/* ================= 4. MEGA FOOTER (DETAILED) ================= */}
      <footer className="bg-slate-900 text-slate-400 py-20 px-6 border-t-[10px] border-yellow-400 mt-auto">
        <div className="max-w-7xl mx-auto grid md:grid-cols-12 gap-16">
          
          {/* Brand */}
          <div className="md:col-span-5 space-y-8">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 bg-green-600 text-white rounded-xl flex items-center justify-center text-2xl font-black">V</div>
              <span className="text-3xl font-black text-white uppercase tracking-tighter">Vidya Classes</span>
            </div>
            <p className="text-base leading-relaxed font-light pr-6">Since 2010, Vidya Classes has been a pioneer in medical and engineering entrance exams. With over 10,000 successful selections, we are committed to providing quality education that turns dreams into reality.</p>
            <div className="flex gap-4">
              <span className="w-10 h-10 border border-slate-800 rounded-full flex items-center justify-center text-xs font-bold hover:bg-green-600 hover:text-white transition cursor-pointer">IG</span>
              <span className="w-10 h-10 border border-slate-800 rounded-full flex items-center justify-center text-xs font-bold hover:bg-green-600 hover:text-white transition cursor-pointer">FB</span>
              <span className="w-10 h-10 border border-slate-800 rounded-full flex items-center justify-center text-xs font-bold hover:bg-green-600 hover:text-white transition cursor-pointer">YT</span>
            </div>
          </div>

          {/* Quick Links */}
          <div className="md:col-span-3 space-y-6">
             <h4 className="font-bold text-white uppercase tracking-widest text-xs">Explore</h4>
             <ul className="space-y-4 text-sm font-medium">
                {['Home', 'Courses', 'Faculty', 'Results', 'Admissions'].map(l => (
                   <li key={l}><button onClick={() => setCurrentPage(l.toLowerCase() as Page)} className="hover:text-yellow-400 transition">{l}</button></li>
                ))}
             </ul>
          </div>

          {/* Address */}
          <div className="md:col-span-4 space-y-6">
             <h4 className="font-bold text-white uppercase tracking-widest text-xs">Our Centers</h4>
             <div className="space-y-4 text-sm font-light">
                <p className="flex gap-4"><span className="text-yellow-400">📍</span> Vidya Towers, Main Mall Road, Sector 15, New Delhi - 110001</p>
                <p className="flex gap-4"><span className="text-yellow-400">📞</span> Admissions: +91 98765 43210</p>
                <p className="flex gap-4"><span className="text-yellow-400">🕒</span> Mon - Sat: 9:00 AM to 8:00 PM</p>
             </div>
          </div>
        </div>

        <div className="max-w-7xl mx-auto border-t border-slate-800 mt-20 pt-8 flex flex-col md:flex-row justify-between items-center gap-6 text-[10px] font-bold tracking-widest uppercase text-slate-600">
           <p>© {new Date().getFullYear()} VIDYA CLASSES PRIVATE LIMITED.</p>
           <div className="flex gap-10">
              <a href="#" className="hover:text-white transition">Privacy Policy</a>
              <a href="#" className="hover:text-white transition">Terms of Service</a>
              <span className="text-green-900">Education Portfolio Demo</span>
           </div>
        </div>
      </footer>

      {/* Animations */}
      <style dangerouslySetInnerHTML={{ __html: `
        @keyframes slideUp { from { opacity: 0; transform: translateY(30px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        .animate-slideUp { animation: slideUp 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards; }
        .animate-fadeIn { animation: fadeIn 0.4s ease-out forwards; }
      `}} />
    </div>
  );
};

export default CoachingMid;